import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: "root"
})
export class HttpActivityService {
  private activeRequests = 0;
  private readonly activeRequestsSubject = new BehaviorSubject<number>(0);
  public readonly activeRequests$ = this.activeRequestsSubject.asObservable();
  private lastActivityTimestamp = Date.now();

  public increment(): void {
    this.activeRequests++;
    this.activeRequestsSubject.next(this.activeRequests);
  }

  public decrement(): void {
    if (this.activeRequests <= 0) {
      return;
    }

    this.activeRequests--;

    if (this.activeRequests === 0) {
      this.lastActivityTimestamp = Date.now();
    }

    this.activeRequestsSubject.next(this.activeRequests);
  }

  public hasActiveRequests(): boolean {
    return this.activeRequests > 0;
  }

  public getActiveRequestCount(): number {
    return this.activeRequests;
  }

  public getIdleTime(): number {
    return Date.now() - this.lastActivityTimestamp;
  }

  public isIdleFor(milliseconds: number): boolean {
    return !this.hasActiveRequests()
      && (Date.now() - this.lastActivityTimestamp) >= milliseconds;
  }
}
